import { useEffect } from 'react';
import { sendEvent } from '../analytics';

// Observe when a section is meaningfully viewed and send a unified GA4 event.
// Options: threshold (0-1), minVisibleMs (dwell time before firing)
export function useSectionView(sectionId, elementId, options = {}) {
  const { threshold = 0.5, minVisibleMs = 800 } = options;

  useEffect(() => {
    if (typeof window === 'undefined' || !elementId || !sectionId) return;
    const element = document.getElementById(elementId);
    if (!element) return;

    let hasTracked = false;
    let pendingTimer = null;

    const clearPending = () => {
      if (pendingTimer) {
        clearTimeout(pendingTimer);
        pendingTimer = null;
      }
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (hasTracked) return;
        if (entry.isIntersecting && entry.intersectionRatio >= threshold) {
          // Start dwell timer
          clearPending();
          pendingTimer = setTimeout(() => {
            // Fire only once per page view
            hasTracked = true;
            sendEvent('view_section', { section_id: sectionId, engagement_time_msec: 1 });
            observer.disconnect();
          }, minVisibleMs);
        } else {
          // Not intersecting enough, cancel pending
          clearPending();
        }
      });
    }, { threshold: [threshold] });

    observer.observe(element);
    return () => {
      clearPending();
      observer.disconnect();
    };
  }, [sectionId, elementId, threshold, minVisibleMs]);
}


